// extracted by mini-css-extract-plugin
module.exports = {"app":"App-module__app___2vSOp"};